import "./notifications.css"
import { useEffect,useState } from "react";

import BaseNotification from '../../../assets/iconos/notifications/etiquetaNormal.png';
import ImportantNotification from '../../../assets/iconos/notifications/etiquetaImportante.png';
import GlobalNotification from '../../../assets/iconos/notifications/etiquetaGlobal.png';
import { getNotifications, setAsRead, getById } from "../../../Services/NotificationService";

import atencion from '../../../assets/iconos/atencion.svg';
import closeImg from '../../../assets/iconos/cerrar.png';
import DialogModal from "../../Modals/dialogModal";


var current = 1;
const Notifications = (props) => {


  const [notifications, setNotifications] = useState([]);
  const [paginateOptions, setPaginateOptions] = useState({});
  const [showModal, setShowModal] = useState(false)

  const [isOnRead, setIsOnRead] = useState(false);


  const getNotificationData = async () => {

    let rsp = await getNotifications(current);

    if(rsp?.Error == false){
        if(rsp.Data.data.length > 0){
            setNotifications(rsp.Data.data);
            setPaginateOptions({current_page: rsp.Data.current_page, last_page: rsp.Data.last_page});
        }
    }
}

const changeCurrentPage = (num) => {
  current = current + num;
  getNotificationData();
}

const handleSelectElement = (item) => {
    setIsOnRead(item);

    if(!item.is_readed){
      setAsRead(item.id);
      item.is_readed = true;
    }
}

const getNotificationById = async (id) => {

    let rsp = await getById(id);

    if(rsp?.Error == false){
      setIsOnRead(rsp.Data);

      if(!rsp.Data.is_readed){
        setAsRead(rsp.Data.id);
      }

    }else{
      setShowModal(true)
    }
}

useEffect(() => {
    getNotificationData();

    let queryString = new URL(window.location.href);
    let id = queryString.searchParams.get("id_notification");

    if(id != '' && id != null){
      getNotificationById(id);
    }
}, []);


  return (
    <div className='frame'>
      <DialogModal showModal={showModal} setShowModal={setShowModal}>
        <h3>No fue posible encontrar la notificacion solicitada.</h3>
      </DialogModal>
        {
          isOnRead ? 
          <div className='noti-page-container-view'>
            <img src={closeImg} className="noti-page-close-btm" onClick={() => setIsOnRead(false)}/>
            <div className="noti-page-conteiner-view-content">
                <h2>{isOnRead.title}</h2>
                <br />
                <div dangerouslySetInnerHTML={{__html: isOnRead.body}}>

                </div>
            </div>
          </div>
          :
          <div className='noti-page-container'>
            <h2>Notificaciones</h2>
            <h4>Pagina {paginateOptions.current_page} de {paginateOptions.last_page} </h4>
            <div className="noti-element-container">
              {
                notifications?.map(item => {
                  return(
                    <div className={item.is_readed ? "noti-container-large" : "noti-container-large-unread"} key={item.id + 'ntf'} onClick={() => handleSelectElement(item)}>
                      <div className="noti-isRead-icon-container">
                        {
                          item.is_readed ?
                          <></>
                          :
                          <img src={atencion} className="atencion" />
                        }
                      </div>
                      <div className="noti-icon-large">
                        <img src={item.id_notification_type === 1 ? GlobalNotification : item.id_notification_type == 2 ? BaseNotification : ImportantNotification} alt="noti-icon"  className="noti-icon"/>
                      </div>
                      <a to="/cursada/1/revision">
                        <div className="noti-large-content-text">
                          <h3>{item.title}</h3>
                        </div>
                      </a>
                      <div className="date-time-notification-date">
                        <a style={{color:''}}>{item.created_at.split('T')[0]}<br/>{item.created_at.split('T')[1].split('.')[0]}</a>
                      </div>
                    </div>)
                    })
              }
              <div className="notifications-paginate-controls">
                {
                  paginateOptions.current_page != 1 ? 
                    <button className="green-btn" onClick={() => changeCurrentPage(-1)}>Anterior</button>
                  :
                    <></>
                }
                {
                  paginateOptions.current_page < paginateOptions.last_page ?
                    <button className="green-btn" onClick={() => changeCurrentPage(+1)}>Siguiente</button>
                  :
                    <></>
                }
              </div>
            </div>
        </div>
        }
    </div>
  )
}

export default Notifications